<div class="header-wrapper">
    <h1 mat-dialog-title class="title">{{ data.title | translate | async }}</h1>
</div>
<div mat-dialog-actions>
    <vue-flat-button (clicked)="closeDialog()">
      {{ "button.ok" | translate | async }}
    </vue-flat-button>
  </div>
